import { ICreateAndUpdateArea } from "../../../types/area.interface";
import customAxios from "../../customAxios";
import { UPDATE_AREA } from "../../routes";

const updateArea = async (props: ICreateAndUpdateArea) => {
  const body: ICreateAndUpdateArea = {
    name: props?.name,
  };

  try {
    return (await customAxios.put(UPDATE_AREA + `/${props._id}`, body)).data;
  } catch (error: unknown) {
    console.error({ UPDATE_AREA: error });
    return false;
  }
};

export default updateArea;
